<template>
  <b-row>
    <b-col md="12" cols="12">
      <table
        stickycolumn="true"
        role="table"
        class="table b-table table-striped table-borderless border"
      >
        <thead role="rowgroup">
          <tr role="row">
            <th role="columnheader" scope="col">{{ $lang.competency }}</th>
            <th role="columnheader" scope="col">{{ $lang.score }}</th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          <tr
            role="row"
            v-for="(competency, index) in competencies"
            :key="index"
          >
            <td role="cell">
              <b-row>
                <b-col>
                  {{ competency.competency.caption }}
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="showDescription(competency)"
                  >
                    <i class="fas fa-file-alt"></i>
                  </b-button>
                </b-col>
              </b-row>
              <b-collapse v-model="competency.collapsed" class="mt-2">
                <b-row>
                  <b-col>
                    <div
                      v-if="competency.final_description"
                      v-html="competency.final_description"
                    ></div>
                    <div v-else>{{ $lang.noDescription }}</div>
                  </b-col>
                </b-row>
              </b-collapse>
            </td>
            <td role="cell">{{ competency.score }}</td>
          </tr>
        </tbody>
      </table>
    </b-col>
    <b-col md="12" cols="12">
      <LoadingSpinner :loading="isLoading" :text="loadingSpinnerText" />
      <b-form v-if="!isLoading">
        <b-form-group
          :label="$lang.exercise_overall"
          label-for="name"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.exercise_overall"
            :rules="$v.overall.$params"
          />
          <b-form-textarea
            data-testid="name"
            type="text"
            name="overall"
            class="name"
            :autocomplete="$lang.exercise_overall"
            :state="$v.overall.$dirty ? !$v.overall.$error : null"
            v-model="$v.overall.$model"
          ></b-form-textarea>
          <b-form-invalid-feedback id="name-feedback"
            >{{ $lang.error_required | replace($lang.exercise_overall) }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          :label="$lang.strength_and_development"
          label-for="description"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.strength_and_development"
            :rules="$v.strength_and_development.$params"
          />
          <b-form-textarea
            name="description"
            data-testid="description"
            :state="
              $v.strength_and_development.$dirty
                ? !$v.strength_and_development.$error
                : null
            "
            v-model="$v.strength_and_development.$model"
            type="text"
            :autocomplete="$lang.strength_and_development"
            :rows="this.$config.form.textareaRows"
          ></b-form-textarea>
          <b-form-invalid-feedback id="description-feedback">
            {{
              $lang.error_required | replace($lang.strength_and_development)
            }}</b-form-invalid-feedback
          >
        </b-form-group>

        <b-form-group
          :label="$lang.category"
          label-for="category_id"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.overall_rating"
            :rules="$v.overall_rating.$params"
          />

          <selectFind
            name="category_id"
            :options="score_options"
            v-model="$v.overall_rating.$model"
            label="text"
            id="value"
            :isValid="
              $v.overall_rating.$dirty ? !$v.overall_rating.$error : null
            "
            :loading="overallRatingLoading"
          />

          <b-form-invalid-feedback id="category_id-feedback"
            >{{ $lang.error_required | replace($lang.category) }}
          </b-form-invalid-feedback>
        </b-form-group>

        <!-- <b-form-group
          :label="$lang.case_parvandeh_status"
          label-for="case_parvandeh_status"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.case_parvandeh_status"
            :rules="$v.case_parvandeh_status_selected.$params"
          />

          <selectFind
            name="case_parvandeh_status"
            :options="parvandehStatusOptions"
            v-model="$v.case_parvandeh_status_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.case_parvandeh_status_selected.$dirty
                ? !$v.case_parvandeh_status_selected.$error
                : null
            "
          />

          <b-form-invalid-feedback id="case_parvandeh_status-feedback"
            >{{ $lang.error_required | replace($lang.case_parvandeh_status) }}
          </b-form-invalid-feedback>
        </b-form-group> -->

        <b-row class="combo-buttons mx-0">
          <b-col
            v-for="(item, index) in comboButtonItems"
            :key="index"
            cols="12"
            :md="item.mdSize"
            class="text-center mb-2"
            @click="save(item)"
          >
            <div
              class="combo-buttons__item w-100"
              :class="`combo-buttons__item--${item.direction} ${
                item.disabled ? 'disabled' : ''
              }`"
            >
              <span class="px-3 position-relative" v-text="item.text" />
            </div>
          </b-col>
        </b-row>

        <!--  <div slot="footer" class="form-group form-btn">
          <b-button
            data-testid="submit-button"
            type="submit"
            :disabled="!isEditable"
            size="md"
            variant="success"
          >
            {{ $lang.submitButton }}
            <i class="fa fa-check"></i>
          </b-button>
        </div> -->
      </b-form>
    </b-col>
    <Confirm
      :title="modalTitle"
      :description="message"
      v-model="confirmModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="okConfim"
      @cancel="cancelConfim"
    />
  </b-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Confirm from "@/components/base/confirm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { renderEumOptions } from "@/shared/utils";
import { pathOr, includes } from "ramda";

export default {
  name: "case-overview",
  components: {
    Confirm,
    LoadingSpinner,
  },
  inject: [
    "centerExecuteCompetencyRepository",
    "centerExecuteCaseOverviewRepository",
    "centerExecuteCaseStatusRepository",
  ],
  validations: {
    overall: {},
    strength_and_development: {},
    overall_rating: {},
    case_status: {},
    // case_parvandeh_status_selected: { required },
  },
  props: {
    case_id: {
      type: [String, Number],
      default: null,
    },
    center_execute_id: {
      type: [String, Number],
      default: null,
    },
    competencies: {
      type: Array,
      default: () => [],
    },
    score_options: {
      type: Array,
      default: () => [],
    },
    // حالت پرونده به دلیل وجود.. اسم به این حاات نوشته شده
    dossier_status: {
      type: Object,
      default: () => {},
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    userExecutiveRoleId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      items: [],
      isLoading: false,
      overall: null,
      strength_and_development: null,
      overall_rating: null,
      overallRatingLoading: false,
      overall_rating_id: null,
      case_status: false,
      status: true,
      confirmModal: false, // بازکردن مدال کانفرم
      modalTitle: "", // عنوان مدال
      message: "", // نمایش متن حذف فایل,
      // case_parvandeh_status_selected: null,
      loadingSpinnerText: this.$lang.receiving_data,
    };
  },
  computed: {
    comboButtonItems() {
      return [
        {
          id: 2,
          text: "ارسال به ناظر کیفی",
          direction: "right",
          mdSize: "4",
          disabled:
            !includes(this.userExecutiveRoleId, [2]) || !this.isEditable, // ارزیاب
        },
        {
          id: 3,
          text: "ارسال به مدیر کانون",
          direction: "right",
          mdSize: "4",
          disabled:
            !includes(this.userExecutiveRoleId, [4]) || !this.isEditable, // مدیر کانون - ناظر کیفی
        },
        {
          id: 4,
          text: "ارسال برای جمع‌بندی",
          direction: "right",
          mdSize: "4",
          disabled:
            !includes(this.userExecutiveRoleId, [3]) || !this.isEditable, // مدیر کانون
        },
        {
          id: 8,
          text: "بازبینی ناظر کیفی",
          direction: "left",
          mdSize: "6",
          disabled:
            !includes(this.userExecutiveRoleId, [3]) || !this.isEditable, // مدیر کانون
        },
        {
          id: 7,
          text: "بازبینی ارزیاب",
          direction: "left",
          mdSize: "6",
          disabled:
            !includes(this.userExecutiveRoleId, [3]) || !this.isEditable, // مدیر کانون
        },
      ];
    },
    /* parvandehStatusOptions() {
      let options = [];
      if (this.userExecutiveRoleId === 2) {
        options = renderEumOptions("case_status").filter((item) =>
          includes(item.value, [2])
        );
      }
      if (this.userExecutiveRoleId === 3) {
        options = renderEumOptions("case_status");
      }
      if (this.userExecutiveRoleId === 4) {
        options = renderEumOptions("case_status").filter((item) =>
          includes(item.value, [1, 3])
        );
      }
      return options;
    }, */
  },
  watch: {
    competencies() {
      this.items = this.competencies.map((x) => {
        return {
          ...x,
          collapsed: false,
        };
      });
    },
    score_options() {
      this.overall_rating = this.score_options.find(
        (x) => x.value == this.overall_rating_id
      );
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    renderEumOptions,
    clearModalConfirm() {
      this.modalTitle = "";
      this.confirmModal = false;
    },
    async okConfim() {
      this.isLoading = true;
      try {
        let payload = {
          status: this.case_status ? 1 : 2,
        };

        let res = await this.centerExecuteCaseStatusRepository.edit(
          this.center_execute_id,
          this.case_id,
          payload
        );
        this.$notify.success(res.data.message);
        this.$emit("caseUpdated");
      } catch (error) {
        this.$generateError(error);
        this.case_status = !checked;
      } finally {
        this.isLoading = false;
      }
      this.clearModalConfirm();
    },
    cancelConfim() {
      this.confirmModal = false;
      this.case_status = false;
      this.clearModalConfirm();
    },
    async changeCaseStatus(checked) {
      checked = checked.target.checked;
      this.case_status = checked;
      this.confirmModal = true;
      this.message = this.$lang.Case_status_confirm_message;
      this.modalTitle = this.$lang.case_status_done;
    },
    async save(buttonItem) {
      const disabled = pathOr(true, ["disabled"], buttonItem);
      if (disabled) return;
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.isLoading = true;
        this.loadingSpinnerText = this.$lang.sending_data;
        const case_status = pathOr(null, ["id"], buttonItem);
        let payload = {
          score: pathOr(null, ["value"], this.overall_rating),
          strength_development_area: this.strength_and_development || null,
          overall: this.overall || null,
          case_status,
        };
        let res = await this.centerExecuteCaseOverviewRepository.edit(
          this.center_execute_id,
          this.case_id,
          payload
        );
        this.$notify.success(res.data.message);
        this.$router.push({ name: "searchCenterExecuteCase" });
        this.$emit("competencyUpdated");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    showDescription(item) {
      item.collapsed = !item.collapsed;
    },
    async getOverview() {
      try {
        this.loadingSpinnerText = this.$lang.receiving_data;
        this.isLoading = true;
        const response = await this.centerExecuteCaseOverviewRepository.find(
          this.center_execute_id,
          this.case_id
        );
        const data = pathOr(null, ["data", "data"], response);

        this.strength_and_development = pathOr(
          null,
          ["strength_development_area"],
          data
        );
        this.overall = pathOr(null, ["overall"], data);
        this.overall_rating = this.score_options.find(
          (x) => x.value == data.score
        );
        this.overall_rating_id = pathOr(null, ["score"], data);
        /*  this.case_parvandeh_status_selected = {
          text: pathOr(null, ["case_status", "caption"], data),
          value: pathOr(null, ["case_status", "id"], data),
        }; */
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    fetchData() {
      this.items = this.competencies.map((x) => {
        return {
          ...x,
          collapsed: false,
        };
      });
      this.getOverview();
    },
  },
};
</script>
<style lang="scss" scoped>
.combo-buttons {
  &__item {
    position: relative;
    color: white;
    padding: 10px;
    font-weight: bold;
    cursor: pointer;
    &::before,
    &::after {
      content: "";
      position: absolute;
      left: 10px;
      height: 50%;
      width: 100%;
      background-color: #0070c0;
      z-index: 1;
    }
    &::before {
      top: -1px;
      transform: skew(330deg);
    }
    &::after {
      bottom: 1px;
      transform: skew(30deg);
    }
    &--left {
      &::before {
        transform: skew(30deg);
      }
      &::after {
        transform: skew(330deg);
      }
    }
    span {
      z-index: 2;
    }
    &:first-child {
      // background-color: #0070c0;
      right: -6px;
      box-sizing: content-box;
    }
    &:last-child {
      right: 1px;
    }
    &:hover {
      opacity: 0.8;
    }
    &.disabled {
      color: #808080;
      cursor: not-allowed;
      &:hover {
        opacity: 1;
      }
      &::before,
      &::after {
        background-color: #c6c6c6;
      }
    }
  }
}
</style>
